import catalog from '../../../city_game/static/city_game/assets/avatars/city-characters-v1.json';
import type { CityAsset } from '../api/types';

export const AVATAR_APPEARANCES: CityAsset[] = catalog.characters;
// Match the stylized shop doors in the kit's 64x32 world; preview zoom is applied separately.
export const AVATAR_BODY_HEIGHT = 42;
const aliases: Record<string,string> = {
  'resident-blue':'city-navy-cap-v1',
  'resident-green':'city-knit-beanie-v1',
  'resident-violet':'city-bucket-hat-v1',
  'citizen-teal-v1':'city-navy-cap-v1',
};

export function resolveAvatarAppearance(id: string): CityAsset | undefined {
  return AVATAR_APPEARANCES.find(asset=>asset.assetId===(aliases[id]??id));
}

/** Heading is clockwise from screen south; columns are idle, then a complete walk. */
export function avatarFrame(asset: CityAsset, heading: number, moving: boolean, seconds: number, speed=1): number {
  const animation=asset.avatarAnimation;
  if(!animation)return 0;
  const row=((Math.round(heading*animation.directions/(Math.PI*2))%animation.directions)+animation.directions)%animation.directions;
  const column=moving?1+Math.floor(Math.max(0,seconds)*animation.fps*speed)%animation.walkFrames:0;
  return row*(asset.spriteSheet?.columns??animation.walkFrames+1)+column;
}
